import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * single read point for the view-as session
 * @returns {{ isViewingAs: boolean, targetId: string | null, requesterId: string | null }}
 */
export default function useViewAs() {
  const viewAsAgent = useSelector(state => state.user.viewAsAgent);
  const mainZohoId = useSelector(state => state.user.mainZohoId);

  return useMemo(
    () => ({
      isViewingAs: Boolean(viewAsAgent),
      targetId: viewAsAgent || null,
      requesterId: mainZohoId || null
    }),
    [viewAsAgent, mainZohoId]
  );
}
